import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'

const ContentCtaCentered = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className={`max-w-7xl mx-auto ${!blok.isContent ? 'md:px-6 my-16' : ''}`}>
                    <div className="mx-auto max-w-[813px] bg-lightgrey py-12 md:px-12 px-6 md:rounded-md">
                        <h4 className="lg:text-lg text-base tracking-[-0.01em] font-semibold">{blok.title}</h4>
                        <div className="prose lg:text-base text-sm mt-4">
                            <RichText>{blok.content}</RichText>
                        </div>
                    </div>
                </div>
            </div>        
        </SbEditable>
    )
}

export default ContentCtaCentered